import { Button, Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/next';

import { TranslatePlural, useI18n } from '@change-corgi/core/react/i18n';

import { DecisionMakerCard } from '../DecisionMakerCard';
import { LegislativeBodyCard } from '../LegislativeBodyCard';

import { useViewAll } from './hooks/useViewAll';

export const ViewAll: React.FC = () => {
	const {
		data: { sortedAllDms, petitionAsk, totalDmCount },
		actions: { trackViewAllDMsClick },
	} = useViewAll();

	const { translate } = useI18n();

	return (
		<Modal
			size="large"
			onClose={() => {}}
			trigger={
				<div className="w-full text-center">
					<Button data-qa="legislative-bodies-show-all" className="w-full" onClick={trackViewAllDMsClick}>
						<TranslatePlural
							value="corgi.petition_gamma.decision_makers_v2.view_all.trigger"
							replacements={{ numberOfDms: totalDmCount }}
							count={totalDmCount}
						/>
					</Button>
				</div>
			}
			className="z-[5000] lg:[&_*]:!col-span-full"
			data-qa="all-decision-makers-modal"
		>
			<ModalHeader title={translate('corgi.petition_gamma.decision_makers_v2.view_all.title')} subtitle={petitionAsk} />
			<ModalBody className="!max-h-none">
				<div className="flex flex-col gap-6">
					{sortedAllDms.map((block) =>
						block.component === 'primary' || block.component === 'individual' ? (
							<DecisionMakerCard key={block.componentDm.id} dm={block.componentDm} />
						) : (
							<LegislativeBodyCard
								key={block.componentAttributes.title}
								legislativeBody={{
									...block.componentAttributes,
									allDMs: block.componentDms,
									displayedDMs: block.componentDms,
									viewMoreCount: 0,
								}}
							/>
						),
					)}
				</div>
			</ModalBody>
		</Modal>
	);
};
